export default "__VITE_ASSET__DxgLHKxJ__"